module.exports = __webpack_public_path__ + "img/filter.a8c54896.png";